import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import { WithSearch } from "@elastic/react-search-ui";
import { observer } from "mobx-react-lite";
import { isEmpty } from "../../utils/nativeUtils";
import { useIntl } from "react-intl";
import config from "../../config";
import { i18nConfig } from "../../i18nConfig";
import { UIStateStoreContext } from "../../stores/uiStateStore";
import { FilterOptionEnum } from "../../models/dataModel";
import { RadioButtonFacet } from "./RadioButtonFacet";
const CategoryFacet = observer(({ labelKey, options, showMore, onChange, onMoreClick, filters, removeFilter, addFilter, clearFilters, hasResolvedCategory, setHasResolvedCategory, }) => {
    const uiStore = useContext(UIStateStoreContext);
    const selected = options.find((option) => {
        return option.selected;
    });
    useEffect(() => {
        if (!hasResolvedCategory && !!selected && !uiStore.getOpenCategory()) {
            resolveOpenCategory(selected, removeFilter, addFilter);
            setHasResolvedCategory(true);
        }
    }, [selected, uiStore.getOpenCategory()]);
    function resolveOpenCategory(selected, removeFilter, addFilter) {
        uiStore.setOpenCategory(selected.value);
        removeFilter(FilterOptionEnum.CATEGORY);
        addFilter(FilterOptionEnum.CATEGORY, selected.value);
    }
    function onSelectCategory(value, clearFilters, addFilter) {
        clearFilters();
        if (uiStore.getOpenCategoryFilters(value)) {
            uiStore.getOpenCategoryFilters(value).forEach((filter) => filter.values.forEach((value) => {
                addFilter(filter.field, value, filter.type);
            }));
        }
        uiStore.setOpenCategory(value);
        onChange(value);
    }
    function handleChange(value) {
        uiStore.setOpenCategoryFilters(filters);
        onSelectCategory(value, clearFilters, addFilter);
    }
    return (_jsx(RadioButtonFacet, { label: labelKey, options: uiStore.getSortedCategoryOptions(), showMore: showMore, onChange: handleChange, onMoreClick: onMoreClick }));
});
/**
 * Renders the facet with the WithSearch render props
 * Gets initial category options from global search service list
 */
const FacetWrapper = observer(({ labelKey, options, showMore, onChange, onMoreClick, }) => {
    const uiStore = useContext(UIStateStoreContext);
    const intl = useIntl();
    const [hasResolvedCategory, setHasResolvedCategory] = useState(false);
    // get details for category facets from options (result count, isSelected)
    useEffect(() => {
        if (!isEmpty(options)) {
            uiStore.setCategoryOptions(options);
        }
    }, [options, uiStore]);
    // on first load, set category facets based on services
    useEffect(() => {
        const serviceOptions = Object.keys(config.services).map((service) => {
            return {
                value: intl.formatMessage({
                    id: `facets.category.${service}`,
                    defaultMessage: i18nConfig.messages["en"][`facets.category.${service}`],
                }),
            };
        });
        uiStore.setCategoryOptions(serviceOptions);
    }, []);
    return (_jsx(WithSearch, { mapContextToProps: ({ clearFilters, removeFilter, addFilter, filters }) => ({
            clearFilters,
            removeFilter,
            addFilter,
            filters,
        }), children: (props) => (_jsx(CategoryFacet, { labelKey: labelKey, options: options, showMore: showMore, onChange: onChange, onMoreClick: onMoreClick, filters: props.filters, clearFilters: props.clearFilters, removeFilter: props.removeFilter, addFilter: props.addFilter, hasResolvedCategory: hasResolvedCategory, setHasResolvedCategory: setHasResolvedCategory })) }));
});
/**
 * Renders the "Select category" facet.
 * @param label name of the facet
 * @param options options for the facet
 * @param onChange handles selecting an option
 */
export const SelectCategoryFacet = ({ label, options, showMore, onChange, onMoreClick, }) => {
    return (_jsx(FacetWrapper, { labelKey: label, options: options, showMore: showMore, onChange: onChange, onMoreClick: onMoreClick }));
};
